<template>
  <v-container fluid>
    <v-row align="center" align-content="center" justify="center">
      <v-col align-self="center" class="fill-height">
        <main-slide v-if="type === 'home'" class="main-slide-height" key="main_slide"></main-slide>
        <functionality-slide v-if="type === 'functionality'" class="func-slide-height"
                             key="func_slide"></functionality-slide>
        <papers-slide v-if="type === 'papers'" key="papers_slide" :papers="papers" :loaded="loaded"></papers-slide>
        <press-slide v-if="type === 'press'" key="press_slide"></press-slide>
        <patents-slide v-if="type === 'patents'" key="patents_slide"></patents-slide>
        <diploma-slide v-if="type === 'diplomas'" key="patents_slide"></diploma-slide>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import FunctionalitySlide from '../components/landing/functionalitySlide'
import MainSlide from '../components/landing/mainSlide'

import { createHelpers } from 'vuex-map-fields'
import { LANDING_MODULE } from '@/store/modules'
import PapersSlide from '../components/landing/papersSlide'
import PressSlide from '../components/landing/pressSlide'
import PatentsSlide from '../components/landing/patentsSlide'

import backend from '@/backend'
import { Paper } from '../models/landing/Paper'
import { firePrerenderEvent, isPrerendered } from '../utils/prerender'
import DiplomaSlide from '../components/landing/diplomaSlide'
import snackbarMixin from '../mixins/snackbarMixin'

const { mapFields } = createHelpers({
  getterType: `${LANDING_MODULE}/getField`,
  mutationType: `${LANDING_MODULE}/updateField`
})

export default {
  name: 'Home',
  components: { DiplomaSlide, PatentsSlide, PressSlide, PapersSlide, MainSlide, FunctionalitySlide },
  computed: {
    ...mapFields(['slide'])
  },
  mixins: [snackbarMixin],
  props: {
    type: {
      type: String,
      default: 'home'
    }
  },
  data: () => ({
    papers: [],
    loaded: false,
  }),
  methods: {
    async getPapers () {
      try {
        const serverPapers = await backend.getPapersList()
        this.papers = []
        for (const localPaper of serverPapers.data) {
          this.papers.push(new Paper(localPaper))
        }
      } catch (e) {

        // we have 401 error here - we can try to get papers again
        const serverPapers = await backend.getPapersList()
        for (const localPaper of serverPapers.data) {
          this.papers.push(new Paper(localPaper))
        }
      }

      // even we have problems - remove skeleton card
      this.loaded = true

      // window.prerenderData = false // JSON.stringify(window)

      // for prerender
      if (isPrerendered()) {
        this.$nextTick(() => firePrerenderEvent())
      }
    }
  },
  async beforeRouteUpdate () {
    await this.getPapers()
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      if (to.params.hasOwnProperty('authError')) {
        vm.openFailureSnackbar('$vuetify.errors.unauthorizedError')
      }

      await vm.getPapers()
    })
  }
}
</script>

<style scoped>
  .func-slide-height {
    /*height: 100vh;*/
  }

  .main-slide-height {
    /*height: 100vh;*/
  }
</style>
